module.exports = __webpack_public_path__ + "static/img/vip.ee5f622.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vip.png
// module id = eIVD
// module chunks = 128